<template>
  <div class="listRoom-container">
    <h1 class="title-list">{{ $t('rooms.roomList') }}</h1>
    <div v-if="loading" class="loader-block">
      <Loader />
    </div>
    <div class="notFoundMessage mt-5" v-else-if="rooms.length === 0">{{ $t('rooms.noRooms') }}</div>
    <div v-else>
      <div v-for="(room, index) in rooms" :key="index">
        <ItemOfRooms :room="room" />
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import ItemOfRooms from '@/components/rooms/ItemOfRooms.vue'

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ListOfRooms',

  components: {
    Loader,
    ItemOfRooms
  },

  created() {
    this.$store.dispatch('getRoomLive', this.userId)
  },

  computed: {
    ...mapGetters(['userId']),
    ...mapState({
      loading: state => state.loading,
      rooms: state => state.rooms
    })
  }
}
</script>

<style lang="sass" scoped>
.listRoom-container
  max-width: 650px
  padding: 10px
  margin: 0 auto

.loader-block
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center

.notFoundMessage
  text-align: center
  opacity: .2
  font-size: 22px

.title-list
  border-bottom: 1px solid rgba(0, 0, 0, .2)
  margin-bottom: 20px
</style>
